module.exports = __webpack_public_path__ + "somaliland.svg?2b344979f3b03937541406a94996e249";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/somaliland.svg
// module id = 298
// module chunks = 10